import React from "react";
import { SpinnerProps } from "./types";
import { Box } from "../Box";
import { Image } from "../Image";
import styled from "styled-components";

const Rotate = styled.div`
  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  animation: rotate 2s linear infinite;
`;

const Spinner: React.FC<React.PropsWithChildren<SpinnerProps>> = ({ size = 128 }) => {
  return (
    <Box width={size} height={size * 1.197} position="relative">
      <Rotate>
        <Image
          width={size}
          height={size * 1.197}
          src="/newImages/_global/icon-color-Toast_loading.svg"
          alt="pancake-3d-spinner"
        />
      </Rotate>
      {/* <p style={{ width: "100%", fontSize: "14px", color: "#FFFFFF", textAlign: "center" }}>Loding...</p> */}
    </Box>
  );
};

export default Spinner;
